import { registerSW } from 'virtual:pwa-register';
import toast from 'react-hot-toast';

/**
 * Registers the service worker and surfaces update / offline-ready toasts.
 * Called once from main.tsx so the scanner page keeps working offline.
 */
// Bump this whenever we ship a fix that requires evicting a stale SW/cache
// from users' browsers. Any client whose stored bust-token doesn't match
// will unregister all SWs and wipe caches once, then continue normally.
const SW_BUST_TOKEN = '2026-05-04-approve-sheet-id-fix';

async function evictStaleServiceWorkers() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister().catch(() => {})));
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => {})));
    }
  } catch {
    // best-effort; never block the app
  }
}

export function setupPWA() {
  // One-shot eviction of any previously-installed SW + caches when the bust
  // token changes. Fixes the "stale SW serving cached 500" failure mode
  // without asking the user to clear site data manually.
  try {
    const stored = localStorage.getItem('sw-bust-token');
    if (stored !== SW_BUST_TOKEN) {
      localStorage.setItem('sw-bust-token', SW_BUST_TOKEN);
      evictStaleServiceWorkers();
    }
  } catch {
    // localStorage unavailable — just continue
  }

  const updateSW = registerSW({
    onNeedRefresh() {
      toast('New version available. Refreshing…', { duration: 3000 });
      setTimeout(() => updateSW(true), 2000);
    },
    onOfflineReady() {
      toast.success('Spares IMS is ready to work offline.');
    },
  });
}
